<template>
  <div class="columns sc-filter-all__col">
    <div class="column">
      <sc-field
        label="Transportadora"
        prop="logisticProviderIds"
        :class="{'field--required': fields.warehouseIds.length < 1}">
          <sc-lp-taginput
            v-model="fields.logisticProviderIds"
            :active="false"
            :form-fields="fields"/>
      </sc-field>
    </div>

    <div class="column">
      <sc-field
        label="Origem"
        prop="warehouseIds"
        :class="{'field--required': fields.logisticProviderIds.length < 1}">
          <sc-warehouse-taginput 
            v-model="fields.warehouseIds"
            :listUser="true"
            :form-fields="fields"/>
      </sc-field>
    </div>
    
    <div class="column">
      <sc-field label="Status" prop="localizedStatus">
        <sc-select
          v-model="fields.localizedStatus"
          expanded>
            <option :value="null">Selecione</option>
            <option
              v-for="localizedStatus in getLocalizedStatus"
              :key="localizedStatus.id"
              :value="localizedStatus.id">
                {{ localizedStatus.label }}
            </option>
        </sc-select>
      </sc-field>
    </div>

    <div class="column">
      <sc-field
        label="Período"
        prop="dateRange">
        <sc-range-date-picker
          v-model="fields.dateRange"
          :format="formatDate"
          :max-date="getMaxDate()"
          required/>
      </sc-field>
    </div>
  </div>
</template>

<script>
  import { Moment } from '@intelipost-js/secure-providers';
  import {
    ScSelect,
    ScField,
    ScRangeDatePicker,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';
  import ScLpTaginput from '../ScLpTaginput';
  import ScWarehouseTaginput from '../ScWarehouseTaginput';
  import LocalizedStateEnumFilter from '../../enums/localizedStatusFilter.enum';

  const { mapState } = createNamespacedHelpers('psl/pslList');

  export default {
    name: 'sc-psl-list-filter-by-all',
    props: {
      fields: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState([
        'filters',
      ]),
      getLocalizedStatus() {
        return LocalizedStateEnumFilter;
      },
    },
    methods: {
      getMaxDate() {
        return Moment().toDate();
      },
      formatDate({ start, end }) {
        return {
          start: Moment(start).format('YYYY-MM-DD'),
          end: Moment(end).format('YYYY-MM-DD'),
        };
      },
    },
    components: {
      ScSelect,
      ScField,
      ScRangeDatePicker,
      ScLpTaginput,
      ScWarehouseTaginput,
    },
  };
</script>
<style lang="scss" scoped>
  .sc-filter-all__col {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-psl/features/list/components/sc-psl-list-filters/ScPslFilterByAll.vue?8731e4e0